import { render, staticRenderFns } from "./calendar-door.vue?vue&type=template&id=6e9f2a80&lang=pug&"
import script from "./calendar-door.vue?vue&type=script&lang=js&"
export * from "./calendar-door.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports